module.exports = function getResource(label, vars = []) {
    let resources = {
        title: 'Récompenses Beauty Insider'
    };

    return resources[label];
};
